import {ReactNode, useMemo} from "react";
import {Home, Repeat, ShoppingCart} from "lucide-react";
import {ZyusetuType} from "@/graphql/graphql";
import {useUserData} from "@/hooks/use-user-data-provider";
import {Permission} from "@/utils/permissions";
import {MultiSelectorCard} from "@/components/input/MultiSelectorCard";

// テンプレートの型定義
export interface Template {
  type: string;
  label: string;
  icon: ReactNode;
  path: string;
  tooltip?: string;
  isAvailable?: boolean;
}

interface ZyusetuTemplateSelectorProps {
  onSelect: (template: Template) => void;
}

export function ZyusetuTemplateSelector({onSelect}: ZyusetuTemplateSelectorProps) {
  const userData = useUserData();
  const hasWritePermission = useMemo(() => userData.permissions.includes(Permission.WriteZyusetu), [userData.permissions]);

  // テンプレート一覧
  const templates: Template[] = [
    {
      type: "rent-new",
      label: "普通・定期賃貸借（新規）",
      isAvailable: true,
      icon: <Home size={40} color="#1a73e8"/>,
      path: `/zyusetu/new/${ZyusetuType.Rent}`,
    },
    {
      type: "rent-renewal",
      label: "普通・定期賃貸借（更新）",
      icon: <Repeat size={40} color={'gray'}/>,
      tooltip: !hasWritePermission ? "権限がありません" : "現在開発中です。しばらくお待ち下さい",
      path: "#",
    },
    {
      type: "sale",
      label: "売買",
      icon: <ShoppingCart size={40} color={'gray'}/>,
      tooltip: !hasWritePermission ? "権限がありません" : "現在開発中です。しばらくお待ち下さい",
      path: import.meta.env.PROD ? "#" : `/zyusetu/new/${ZyusetuType.Sale}`
    },
  ];

  return (
    <MultiSelectorCard
      onSelect={onSelect}
      options={templates}
    />
  );
}
